import {IModelConfig, IViewItemConfig} from "../../../data/IViewpoint";
import {ICameraViewCamera, ICameraViewViewpoint} from "../../../unreal/BigScreenCommunity3D";

export function getCameraInfo(selectedViewItem: IViewItemConfig, modelConfig: IModelConfig | null, lotId: string, levelId: string) {
    if (selectedViewItem === undefined || modelConfig === null) {
        return undefined;
    }
    if (selectedViewItem.type === "camera") {
        const cameraId = lotId ? `${lotId}-${selectedViewItem.camera}` : `GL_${levelId}_${selectedViewItem.camera}`;
        const retval: ICameraViewCamera = {
            cameraId: cameraId,
            type: "camera"
        };
        return retval;
    }
    if (selectedViewItem.type === "view") {
        const cameraId = lotId + " " + selectedViewItem.camera;
        const retval: ICameraViewCamera = {
            cameraId: cameraId,
            type: "camera"
        };
        return retval;

    }
    if (selectedViewItem.type === "viewpoint") {
        const cameraId = selectedViewItem.camera;

        const viewpoint = modelConfig.viewpointGroupDefinition?.Viewpoints.find(vp => vp.Name === cameraId);
        if (viewpoint === undefined) {

            console.error('viewpoint camera activated, but viewpoint group not defined!');
            return undefined;
        }
        const retval: ICameraViewViewpoint = {
            type: "viewpoint",
            relativeTo: lotId,
            viewpoint: viewpoint
        }
        return retval;
    }
}